/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
// Context

// eslint-disable-next-line react/jsx-props-no-spreading
export default function CollectionStatusOptionModa({
  statusModal,
  setStatusModal,
  statusOptions,
  handleChangeCollectionStatus,
}) {
  const handleClose = () => {
    setStatusModal(false);
  };
  return (
    <Dialog onClose={handleClose} open={statusModal}>
      <DialogTitle>Choose Collection Status</DialogTitle>
      <List sx={{ pt: 0 }}>
        {statusOptions?.map((row) => (
          <ListItem disableGutters>
            <ListItemButton onClick={() => handleChangeCollectionStatus(row)}>
              <ListItemText primary={row?.description} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

CollectionStatusOptionModa.defaultProps = {
  statusModal: false,
  setStatusModal: () => {},
  statusOptions: [],
  handleChangeCollectionStatus: () => {},
};

CollectionStatusOptionModa.propTypes = {
  statusModal: PropTypes.bool,
  setStatusModal: PropTypes.func,
  statusOptions: PropTypes.array?.isRequired,
  handleChangeCollectionStatus: PropTypes.func,
};
